// extracted by mini-css-extract-plugin
export default {"root":"Logo_root__3K0sO","left":"Logo_left__MtevB","right":"Logo_right__k41iQ","sup":"Logo_sup__TZfI3"};